import { Box } from '@mantine/core';
import type { TransformedTarget } from '../../../../../api/targets-client/targets-client.type';
import { useTargetsTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setSelectedTarget } from '../../../../../store/strategy-store/strategy-store.actions';
import { secondaryLight, skyLightest } from '../../../../../styles/design-tokens';
import { Text } from '../../../../../ui-library/typography/typography';

type Props = {
  target: TransformedTarget;
};

export const TargetItem = ({ target }: Props) => {
  const selectedTarget = useTargetsTabStore((state) => state.selectedTarget);

  const isSelected = target.id === selectedTarget?.id;

  return (
    <Box
      onClick={() => setSelectedTarget(target)}
      style={{
        boxSizing: 'border-box',
        borderRadius: 32,
        padding: '4px 16px',
        border: `1px solid ${isSelected ? secondaryLight : 'transparent'}`,
        backgroundColor: isSelected ? skyLightest : 'transparent',
        cursor: 'pointer',
        width: 254,
      }}
    >
      <Text
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {target.name}
      </Text>
    </Box>
  );
};
